import { Platform } from "react-native";
import * as DeviceTypes from "../components/devices/_deviceTypes";

export const SensorDeviceTypes = [
  DeviceTypes.MOTION_SENSOR,
  DeviceTypes.LIGHT_METER,
  DeviceTypes.THERMO_METER,
  DeviceTypes.HUMIDITY_SENSOR,
  DeviceTypes.VOLTAGE_SENSOR,
  DeviceTypes.DOOR_SENSOR,
  DeviceTypes.LEAK_DETECTOR,
  DeviceTypes.SMOKE_DETECTOR,
  DeviceTypes.SENSOR_BINARY,
];

class AreaModel {
  constructor(area, devices = []) {
    let { deviceTypesCount } = area;
    if (!deviceTypesCount) {
      deviceTypesCount = {};
    }
    this.areaId = area.areaId;
    this.devices = area.devices;
    this.areaUId = area.areaUId;
    this.areaName = area.areaName;
    this.isArmed = area.isArmed;
    this.isBreached = area.isBreached;
    this.isArmable =
      area.isArmable &&
      area.rolesAllowedToArm &&
      (area.rolesAllowedToArm.indexOf(area.accessLevel) >= 0 ||
        (area.rolesAllowedToArm.indexOf("Admin") >= 0 &&
          area.accessLevel == "Support"));
    this.imageSource = area.imageSource;
    this.lights =
      devices.filter(
        (d) =>
          (d.deviceType == DeviceTypes.LIGHT ||
            d.deviceType == DeviceTypes.LIGHT_DIMMER) &&
          d.showOnHomeScreen
      ).length ||
      deviceTypesCount.lights ||
      0;
    this.blinds =
      devices.filter(
        (d) => d.deviceType == DeviceTypes.CURTAIN && d.showOnHomeScreen
      ).length ||
      deviceTypesCount.blinds ||
      0;
    this.hvacs =
      devices.filter(
        (d) =>
          d.deviceType == DeviceTypes.AIR_CONDITIONER &&
          !d.statusRelayId &&
          d.showOnHomeScreen
      ).length ||
      deviceTypesCount.hvacs ||
      0;
    this.cameras =
      devices.filter(
        (d) =>
          d.deviceType == DeviceTypes.CAMERA &&
          d.showOnHomeScreen &&
          (!d.isV380 || Platform.OS === "android") //&& !d.doorLockDeviceId
      ).length ||
      deviceTypesCount.cameras ||
      0;
    this.smartSpeakers =
      devices.filter(
        (d) => d.deviceType == DeviceTypes.SMART_SPEAKER && d.showOnHomeScreen
      ).length ||
      deviceTypesCount.smartSpeakers ||
      0;
    this.cameraDoorlocks =
      devices.filter(
        (d) =>
          d.deviceType == DeviceTypes.CAMERA &&
          (d?.doorLockDeviceId > 0 || d.doorLockDeviceUId) &&
          d.showOnHomeScreen
      ).length ||
      deviceTypesCount.cameraDoorlocks ||
      0;
    this.switches =
      deviceTypesCount.switches ||
      devices.filter(
        (d) => d.deviceType == DeviceTypes.POWER_SWITCH && d.showOnHomeScreen
      ).length;

    this.elevators =
      deviceTypesCount.elevators ||
      devices.filter(
        (d) => d.deviceType == DeviceTypes.ELEVATOR && d.showOnHomeScreen
      ).length;
    this.wateringSwitches =
      deviceTypesCount.wateringSwitch ||
      devices.filter(
        (d) => d.deviceType == DeviceTypes.WATERING_SWITCH && d.showOnHomeScreen
      ).length;

    this.outlets =
      devices.filter(
        (d) => d.deviceType == DeviceTypes.OUTLET && d.showOnHomeScreen
      ).length ||
      deviceTypesCount.outlets ||
      0;

    this.sirens =
      devices.filter(
        (d) => d.deviceType == DeviceTypes.SIREN && d.showOnHomeScreen
      ).length ||
      deviceTypesCount.sirens ||
      0;

    this.locks =
      devices.filter(
        (d) => d.deviceType == DeviceTypes.DOORLOCK && d.showOnHomeScreen
      ).length ||
      deviceTypesCount.locks ||
      0;

    // this.accessControls = this.locks =
    this.accessControls =
      devices.filter(
        (d) => d.deviceType == DeviceTypes.ACCESS_CONTROL && d.showOnHomeScreen
      ).length ||
      deviceTypesCount.accessControls ||
      0;
    var _sensors = devices.filter(
      (d) => SensorDeviceTypes.indexOf(d.deviceType) >= 0 && d.showOnHomeScreen
    );

    // var _countableSensors = [..._sensors];
    // for (const i in _sensors) {
    //   const dvc = _sensors[i];
    //   if (
    //     dvc.deviceType == DeviceTypes.LIGHT_METER &&
    //     _sensors.some(
    //       (d) =>
    //         (d?.deviceId == dvc?.deviceId || d.deviceUId == dvc.deviceUId) &&
    //         d.deviceType != DeviceTypes.LIGHT_METER
    //     )
    //   ) {
    //     continue;
    //   }
    //   _countableSensors.push(dvc);
    // }

    this.sensors = _sensors.length || 0;
    this.armReport = area.armReport || {};
    this.relatedAreaPowerMeterId = area.relatedAreaPowerMeterId;
    this.relatedAreaWaterMeterId = area.relatedAreaWaterMeterId;
    this.userDefinedStates =
      area.userDefinedStates.filter((s) => s.canShowOnHomeScreenArea) || [];
    this.hasPublicAreaState = this.userDefinedStates.length > 0;
  }
}

export default AreaModel;
